import React from "react";
import { makeStyles } from "@mui/styles";
import Box from "components/common/Box";
import Grid from "components/common/Grid";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import Button from "./Button";

const DatePickerModal = ({
  from_date,
  to_date,
  handleChange,
  onDatePickerSub,
  onClose,
  handleReset
}) => {
  const classes = useStyles();

  return (
    <>
      <Grid
        container
        spacing={3}
        className={classes.DateContainerMain}
        sx={{ width: "602px", minHeight: "300px",   cursor:'pointer' }}
      >
        <Grid item xs={6}>
          <div className={classes.DateContainer}>
            <p className="text-center">
              <span className="bold">From:</span> {from_date}
            </p>
            <Box className={classes.calendarContainer}>
              <Calendar
                className={classes.calendarCls}
                onChange={(e) => handleChange("from_date", e)}
                value={from_date ? new Date(from_date) : new Date()}
                maxDate={new Date()}
              />
            </Box>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div className={classes.DateContainer}>
            <p className="text-center">
              <span className="bold">To:</span> {to_date}
            </p>
            <div className={classes.calendarContainer}>
              <Calendar
                className={classes.calendarCls}
                onChange={(e) => handleChange("to_date", e)}
                value={to_date ? new Date(to_date) : new Date()}
                maxDate={new Date()}
                minDate={from_date ? new Date(from_date) : new Date()}
              />
            </div>
          </div>
          <Button
            onClick={() => {
              onDatePickerSub();
              onClose();
            }}
            disabled={!to_date}
            sx={{ float: "right", marginTop: "5px", fontSize: "12px" }}
          >
            Submit
          </Button>
          <Button
            onClick={()=>{handleReset(); onClose();}}
            
            disabled={!to_date}
            sx={{ float: "right", marginTop: "5px", fontSize: "12px", marginRight:'10px' }}
          >
            Reset
          </Button>
         
        </Grid>
      </Grid>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  calendarContainer: {
    "& .react-calendar": {
      padding: "15px 10px !important",
    },
    "& .react-calendar__navigation button": {
      fontSize: "22px",
      color: "#707070",
    },
    "& .react-calendar__navigation__arrow": {
      border: "1px solid #19AA69!important",
      color: "#19AA69 !important",
      borderRadius: "5px",
    },
    "& .react-calendar__navigation__next2-button": {
      display: "none",
    },
    "& .react-calendar__navigation__prev2-button": {
      display: "none",
    },
  },
  calendarCls: {
    "& .react-calendar__tile": {
      padding: "15px 10px",
      border: "1px solid #e5e5e5 !important",
      borderRadius: "5px",
    },
    "& .react-calendar__month-view__days__day--weekend": {
      color: "#000000",
    },
    "& .react-calendar__month-view__weekdays__weekday abbr": {
      textDecoration: "none !important",
    },
    "& .react-calendar__tile:enabled:hover": {
      backgroundColor: "#e6e6e6",
    },
    "& .react-calendar__tile--now": {
      background: "#757575",
      color: "white !important",
    },
    "& .react-calendar__tile--active": {
      background: "#19AA69 !important",
      color: "white !important",
    },
    "& .react-calendar__tile--hasActive": {
      background: "#19AA69 !important",
      color: "white !important",
    },
    "& .react-calendar__tile--hasActive:enabled:hover": {
      background: "#19AA69 !important",
      color: "white !important",
    },
    "& .react-calendar__tile--hasActive:enabled:focus": {
      background: "#19AA69 !important",
      color: "white !important",
    },
  },
  DateContainer: {
    "@media (max-width:768px)": {
      width: "15rem",
      margin: "none",
    },
  },
  DateContainerMain: {
    "@media (max-width:768px)": {
      width: "auto",
      display: "block",
      margin: "none",
      padding: "5px",
       cursor:'pointer'
    },
  },
}));

export default DatePickerModal;
